
import _ from "lodash";
import rest from "@/rest";
import { Component, Vue, Watch, Prop } from "vue-property-decorator";
import { Action, namespace } from "vuex-class";
import { List } from "linq-collections";
import moment, { duration } from "moment";
import EditSubGroup from "@/components/Groups/EditSubGroup.vue";
import { ExBundleAssignmentGroupVM, ExBundleAssignmentVM } from '../../interfaces/ExBundleAssignmentGroupVM';
import { PortalUserVM, SelectListItem } from "@/interfaces/PortalUserVM";
import { SubGroupVm } from "@/interfaces/SubGroupVm";
import { disableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock';
import { ParamGetExercises } from "@/interfaces/ParamGetExercises";
import { GroupExtVm } from "@/interfaces/GroupExtVm";
import { vuex } from "@/store";

//const auth = namespace("auth");
const globals = namespace("globals");

@Component({
  components: {
    EditSubGroup
  }
})
export default class AssignmentMenu extends Vue {
  @Prop() assignment!: ExBundleAssignmentVM;
  @globals.Getter selectedGroup!: GroupExtVm;
  @globals.Getter selectedSubGroup!: SubGroupVm;

  busyOnSave = false;
  busyOnDelete = false;
  assignmentDateDlg: boolean = false;
  deadlineDateDlg: boolean = false;
  deadlineTimeDlg: boolean = false;
  localShowDialog: boolean = false;
  showPupilSelectionMenu = false;
  showEditSubGroupDialog = false;
  assignedToPupils = 0;
  groupExtVm: GroupExtVm | null = null;
  editSubGroup: SubGroupVm | null = null;
  editAssignment: ExBundleAssignmentVM | null = null;
  assignmentDate: string | null = null;
  deadlineDate: string | null = null;
  deadlineTime: string | null = null;

  // @auth.Getter isAdmin: any;
  // @auth.Getter isOrgAdmin: any;
  // @auth.Getter isGroupAdmin: any;
  // @auth.Getter isParent: any;
  // @auth.Getter isPupil: any;

  mounted() {
    // console.log("AssignmentMenu mounted");
    // Make sure that the showDialog variable of the parent is in sync upon initialization
    // this.$emit('update:showMenu', false);
  }

  beforeDestroy() {
    clearAllBodyScrollLocks();
  }

  async openMenu(on) {
    // console.log("AssignmentMenu openMenu");
    // console.log("on: ", on);
    //this.$emit('update:showMenu', true);
    this.localShowDialog = true;

    await this.loadGroupWithSubGroups();

    this.editAssignment = _.cloneDeep(this.assignment);

    // AssignmentDate
    this.assignmentDate = moment(this.editAssignment.assignmentDate).format("yyyy-MM-DD");
    // console.log("assignmentDate: " + this.assignmentDate);
    // Deadline
    // console.log("deadline:" + this.editAssignment.deadline);
    this.deadlineDate = moment(this.editAssignment.deadline).format("yyyy-MM-DD");
    // console.log("deadlineDate: " + this.deadlineDate);
    this.deadlineTime = moment(this.editAssignment.deadline).format("HH:mm"); // HH => 24h format
    // console.log("deadlineTime: " + this.deadlineTime);

    // Disable body scroll on iOS
    this.$nextTick(async () => {
      await this.$globalHelper.delay(10);
      const modal = document.querySelector('.modal');
      disableBodyScroll(modal);
    });
  }

  async loadGroupWithSubGroups() {
    await rest.url("groupAdmin/getGroup").query({ groupId: this.selectedGroup.id }).get()
      .then((response) => {
        this.groupExtVm = response;
        if (this.selectedSubGroup.id == 0) {
          this.editSubGroup = _.clone(this.selectedSubGroup);
          this.editSubGroup.name = "";
          this.editSubGroup.users = <PortalUserVM[]>[];
        } else {
          this.editSubGroup = new List(this.groupExtVm!.subGroups!).single(s => s.id == this.selectedSubGroup.id);
        }
      })
  }

  // async loadPupilList() {
  //   let param: ParamGetExercises = {
  //     bundleId: this.assignment.exBundle?.id ?? 0,
  //     groupId: this.selectedGroup.id,
  //     subGroupId: this.selectedSubGroup.id,
  //     category1Id: 0, // Not relevant
  //     category2Id: 0, // Not relevant
  //     category3Id: 0, // Not relevant
  //     userId: null,// Not relevant
  //   };
  //   this.pupilAssignments = await rest.url("groupAdmin/getPupilAssignmentsToBundle").post(param);
  // }

  // onGroupSelected() {
  //   if (!this.editAssignment)
  //     return;

  //   this.editAssignment.isAssignedToGroup = true;
  //   this.editAssignment.isAssignedToIndividualUsers = false;
  //   // Restore original values??
  // }

  onEditSubGroup() {
    this.showEditSubGroupDialog = true;
  }

  onSubGroupUpdated(subGroupVm: SubGroupVm) {
    // console.log("subGroupVm: ", subGroupVm);
    vuex.globals.setSubGroup(subGroupVm);
    this.editAssignment!.subGroupId = subGroupVm.id;
    // this.editAssignment!.title += " > " + subGroupVm.name;
    this.loadGroupWithSubGroups();
  }

  // async onSelectUsers() {
  //   if (!this.editAssignment)
  //     return;

  //   // this.loadPupilList();
  //   this.editAssignment.isAssignedToGroup = false;
  //   this.editAssignment.isAssignedToIndividualUsers = true;

  //   clearAllBodyScrollLocks();
  //   this.showPupilSelectionMenu = true; // At this moment the modal class will be removed from base dialog
  //   // Disable body scroll on iOS
  //   this.$nextTick(async () => {
  //     await this.$globalHelper.delay(10);
  //     const modal = document.querySelector('.modal'); // This time we will set the scroll lock to the pupil selection dialog.
  //     disableBodyScroll(modal);
  //   });
  // }

  // selectAll() {
  //   new List(this.pupilAssignments).forEach(a => a.isAssignedToIndividualUsers = true);
  // }

  // clearAll() {
  //   new List(this.pupilAssignments).forEach(a => a.isAssignedToIndividualUsers = false);
  // }

  // applyPupilsList() {
  //   // If active assignment is available, preset assignmentDate and deadlineDate
  //   if (this.editAssignment && new List(this.pupilAssignments).firstOrDefault(a => a.isAssignedToIndividualUsers)) {
  //     let activeAssignment = new List(this.pupilAssignments).firstOrDefault(a => a.isAssignedToIndividualUsers);
  //     this.assignmentDate = moment(activeAssignment!.assignmentDate).format("yyyy-MM-DD");
  //     this.editAssignment.hasDeadline = activeAssignment!.hasDeadline;
  //     this.deadlineDate = moment(activeAssignment!.deadline).format("yyyy-MM-DD");
  //   } else {
  //     // No active assignment available
  //     this.assignmentDate = moment(new Date()).format("yyyy-MM-DD");
  //     this.deadlineDate = moment(new Date()).add(duration(2, "days")).format("yyyy-MM-DD");
  //     this.deadlineTime = moment(new Date("2000-01-01T20:00")).format("HH:mm"); // HH => 24h format
  //   }

  //   //clearAllBodyScrollLocks();
  //   this.showPupilSelectionMenu = false;
  // }

  async updateAssignment(isAssigned: boolean) {
      if (this.editAssignment == null)
        return;

      this.busyOnSave = isAssigned;
      this.busyOnDelete = !isAssigned;

      this.editAssignment.isAssigned = isAssigned;
      // Deadline
      let deadlineDateTime = `${this.deadlineDate}T${this.deadlineTime}`;
      let deadline = moment(deadlineDateTime).toDate();
      this.editAssignment.deadline = deadline;

      let assignmentDate = moment(this.assignmentDate).toDate();
      this.editAssignment.assignmentDate = assignmentDate;

      let updatedAssignment = await rest.url("groupAdmin/updateGroupAssignment").post(this.editAssignment);

      // if (this.editAssignment.isAssignedToIndividualUsers) {
      //   // new List(this.pupilAssignments).forEach(a => a.isAssignedToIndividualUsers = isAssigned);
      //   new List(this.pupilAssignments).forEach(a => a.assignmentDate = assignmentDate);
      //   new List(this.pupilAssignments).forEach(a => a.hasDeadline = this.editAssignment!.hasDeadline);
      //   new List(this.pupilAssignments).forEach(a => a.deadline = deadline);
      //   let updatedAssignment = await rest.url("groupAdmin/updatePupilAssignments").post(this.pupilAssignments);
      // } else {
      //   this.editAssignment.isAssignedToGroup = isAssigned;
      //   this.editAssignment.assignmentDate = assignmentDate;
      //   this.editAssignment.deadline = deadline;
      //   let updatedAssignment = await rest.url("groupAdmin/updateGroupAssignment").post(this.editAssignment);
      // }

      this.$emit("updateView:AssignmentMenu");
      clearAllBodyScrollLocks();
      this.busyOnSave = false;
      this.busyOnDelete = false;
      this.localShowDialog = false;
  }

  adjustDaedlineAndCloseMenu() {
    if (moment(this.assignmentDate).isAfter(moment(this.deadlineDate))) {
      this.deadlineDate = this.assignmentDate;
    }
    this.assignmentDateDlg = false;
  }

  // get subGroupButtonIcon() {
  //   if (!this.groupExtVm || !this.editSubGroup)
  //     return "";
  //   if (this.selectedSubGroup.id == 0)
  //     return "mdi-plus-circle-outline";
  //   else
  //     return "mdi-pencil";
  // }

  get subGroupButtonLable() {
    // if (!this.editAssignment?.isAssignedToIndividualUsers || this.pupilAssignments.length == 0)
    //   return "";
    // if (!this.pupilAssignments)
    //   return "";
    // return `${new List(this.pupilAssignments).count(a => a.isAssignedToIndividualUsers)} / ${new List(this.pupilAssignments).count()}`;
    if (!this.groupExtVm || !this.editSubGroup)
      return "";
    // if (this.selectedSubGroup.id == 0)
    //   return "Neue Untergruppe";
    // else
      return `${this.editSubGroup.name} (${this.editSubGroup.userCount} / ${this.groupExtVm.userCount})`;
  }

  get minDate() {
    //console.log("Now: " + this.$moment().year());
    return new Date().toISOString().substring(0, 10);
  }

  get assignmentDateFormated() {
    return this.formatCalendar(this.assignmentDate);
  }

  get deadlineDateFormated() {
    return this.formatDate(this.deadlineDate);
  }

  // get baseDialogModal () {
  //   if (!this.showPupilSelectionMenu)
  //     return "modal";
  //   return "";
  // }

  // get pupilSelectionDialogModal () {
  //   if (this.showPupilSelectionMenu)
  //     return "modal";
  //   return "";
  // }

  formatDate(date) {
    if (date == null)
      return "-";

    return moment(date).format("DD.MM.yyyy");
  }

  formatCalendar(date) {
    if (date == null)
      return "-";

    let mDate = moment(date);
    if (mDate.date() == moment().date())
      return ("sofort");

    //return this.formatDate(this.editAssignment?.assignmentDate);
    //return  this.$moment(this.editAssignment.assignmentDate).format("dddd DD.MM.YYYY");
    return mDate.calendar();
  }

  // beforeDestroy() {
  //   debugger
  //   clearAllBodyScrollLocks();
  //   this.$emit('update:showDialog', false);
  // }

  // @Watch("showMenu")
  // onShowMenuChanged(val: boolean) {
  //   console.log("AssignmentMenu onShowMenuChanged");
  //   if (val == true) {
  //     // Dialog opened
  //     this.editAssignment = _.cloneDeep(this.assignment);
  //     // const modal = document.querySelector('.modal');
  //     // disableBodyScroll(modal);
  //     // document.getElementsByTagName("body")[0].className="noscroll";
  //     this.localShowDialog = true;
  //   } else {
  //     // Dialog closed
  //     // clearAllBodyScrollLocks();
  //     // document.body.removeAttribute("class","noscroll");
  //     this.localShowDialog = false;
  //   }
  // }

  onCancel() {
    //this.$emit('update:showMenu', false);
    clearAllBodyScrollLocks();
    this.localShowDialog = false;
  }
}
